import { Box } from '@mui/material'
import { t } from 'i18next'

import LexnetToggleButton from 'src/components/shared/ui/form/fields/LexnetToggleButton'
import { TIPO_ORIGEN_OPTIONS } from 'src/components/views/EscritosLexnet/components/IniciadorAsunto/components/Origen/consts'
import { FormField } from 'src/enums/Form'
import { theme } from 'src/providers/ThemeProvider'

const styles = {
  display: 'flex',
  alignItems: 'center',
  height: '32px',
  color: theme.colors.gray14,
  fontFamily: theme.corporate.primaryFont,
  fontSize: '16px',
  marginTop: '8px',
  marginBottom: '20px',

  '& .MuiBox-root': {
    marginBottom: 0
  },

  '& .MuiToggleButton-root': {
    width: '150px',
    marginBottom: 0,
    marginLeft: '10px'
  }
}

function TipoOrigen(): JSX.Element {
  return (
    <Box sx={styles}>
      <Box component="span">{`${t('form.field.organo_origen_tipo')}: `}</Box>
      <LexnetToggleButton id={FormField.ORGANO_ORIGEN_TIPO_ORIGEN} options={TIPO_ORIGEN_OPTIONS} />
    </Box>
  )
}

export default TipoOrigen
